import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import styles from './Join.module.scss';

import Main from '../../components/Main/Main';
import Heading from '../../components/Heading/Heading';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Loading from '../../components/Loading/Loading';
import Form from '../../components/Form/Form';

import Section from '../../components/Section/Section';
import Logo from '../../components/Logo/Logo';

const Join = () => {
  const codeLength = 6;
  const functions = getFunctions();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(location.state?.error);
  const [validCode, setValidCode] = useState(false);
  const [roomCode, setRoomCode] = useState('');
  const [redirectLocation, setRedirectLocation] = useState(false);

  const newRoom = httpsCallable(functions, 'newRoom');

  useEffect(() => {
    if (roomCode.length === codeLength) {
      setValidCode(true);
    } else {
      setValidCode(false);
    }
  }, [roomCode]);

  useEffect(() => {}, []);

  const createRoom = () => {
    setLoading(true);
    newRoom({ length: codeLength }).then((result) => {
      const data = result.data.room;
      if (data === false) {
        setLoading(false);
        setError('Could not create new room');
      } else {
        hostGame(data);
      }
    });
  };

  const hostGame = (code) => {
    redirectTo(`host?code=${code}`);
  };

  const joinRoom = () => {
    setLoading(true);
    redirectTo(`play?code=${roomCode}`);
  };

  const redirectTo = (link) => {
    setRedirectLocation(link);
  };

  if (redirectLocation) {
    return <Navigate to={redirectLocation} />;
  } else if (loading) {
    return <Loading />;
  } else {
    return (
      <Main>
        <Section>
          {error && <div>{error}</div>}
          <Logo />
          <div className={styles.forms}>
            <Form className={styles.createForm}>
              <Heading>Host a game</Heading>
              <Button onClick={createRoom}>Create room</Button>
            </Form>
            <Form>
              <Heading>Join a game</Heading>
              <div className={styles.inlineForm}>
                <Input
                  className={styles.room}
                  uppercase
                  placeholder={'6 Chars'}
                  max={codeLength}
                  onChange={(value) => {
                    setRoomCode(value.toUpperCase());
                  }}
                />
                <Button onClick={joinRoom} disabled={!validCode}>
                  Join
                </Button>
              </div>
            </Form>
          </div>
        </Section>
      </Main>
    );
  }
};

export default Join;
